import getFieldValue from '../elements/getFieldValue';
import getForm from '../elements/getForm';
import { getAdditionalFormFields } from './getMessageValue';
import submitForm from './submitForm';
import { trackFormWizardEvent } from '../../tracking/track_form_wizard_event';
import getFieldsByName from '../elements/getFieldsByName';
import { pushLeadUpdated } from '../../tracking/send_to_gtm';

function getFormUrl(correlationId) {
  return `https://${process.env.API_HOST}/v1/contact/requests?correlationId=${correlationId}`;
}

function fieldExists(form, fieldName) {
  return getFieldsByName(form, fieldName).length > 0;
}

function getFormData(form) {
  const data = [];
  const pushData = (path, value) => data.push({ op: 'replace', path, value });
  const pushField = (path, name, value = getFieldValue(form, name)) => {
    fieldExists(form, name) && pushData(path, value);
  };

  // Add dialer_consent_accepted to the payload if we have the checkbox
  pushField(
    'contact_details/dialer_consent_accepted',
    'dialer_consent_accepted',
    !!getFieldValue(form, 'dialer_consent_accepted')
  );

  // We MUST send phone number too, it is a vt-contact requirement
  pushField('contact_details/phone', 'phone_number');

  // Add callback_time to payload if we have an appropriate field
  pushField('callback_time', 'time_to_call');
  pushField('callback_time', 'callback_time');

  // add flag to determine if calendar invite should be sent
  const send_calendar_invite = document.querySelector('.appointment-scheduler')?.dataset?.calendarInvite == 'true';
  pushData('send_calendar_invite', send_calendar_invite);

  // Dynamically get all 'message' fields and push them
  const messageFields = getAdditionalFormFields(form);
  Object.entries(messageFields).forEach(([key, value]) => pushData(key, value));

  return data;
}

function validateForm(form) {
  if(!getFieldValue(form, 'correlation_id')) {
    throw new Error('correlation_id value is required from lead submission');
  }

  if(!getFieldValue(form, 'phone_number')) {
    throw new Error('Phone number is required');
  }
}

export default async function updateContact(step) {
  const form = getForm(step);
  validateForm(form);

  const correlationId = getFieldValue(form, 'correlation_id');
  const formData = getFormData(form);
  const formVersion = getFieldValue(form, 'leadform');
  const url = getFormUrl(correlationId);

  return submitForm(url, { formData, formVersion }, 'PATCH', { credentials: 'include' })
    .then(pushLeadUpdated(form, { lead_type: 'nsp_form--update_contact' }))
    .then(() => (
      trackFormWizardEvent(step, {
        category: 'form_wizard_submit',
        action: 'lead_update'
      })
    ))
    .catch(() => {
      trackFormWizardEvent(step, {
        category: 'form_wizard_submit_failure',
        action: 'lead_update_failure'
      });
      throw new Error('Server error, could not submit form.');
    });
}
